function Blog() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Blog</h1>
        <br></br>
        <div className="flex flex-col items-center space-y-4"></div>
      </div>
    </div>
  );
}

export default Blog;
